jQuery(function($) {
  $('.show-comments--button').click(function(e) {
    e.preventDefault();
    $('#disqus_thread').fadeIn(800);
    $(this).fadeOut(850);
  });
});